
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 74.375 85","fill":"#fff","fill-rule":"evenodd","stroke":"#000","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 19.995L35 0l35 19.995v40.009L35 80 0 60.005v-40.01z"}}),_c('path',{attrs:{"d":"M23.97 36.293h14.265v3.688H23.97zm0 7.386h14.265v3.688H23.97zm0 7.385h14.265v3.688H23.97zm17.945-19.929v21.398h3.68V27.447H27.65v3.688h14.265z","fill":"#000"}}),_c('path',{attrs:{"d":"M52.973 20.09H23.97v7.386h-7.369v36.132h28.993v-7.386h7.378zM41.915 59.91H20.281V31.135h21.634zm7.369-7.386h-3.689V27.447H27.621V23.75h21.662z","fill":"#000"}})])
          )
        }
      }
    